import React from "react";
import { motion } from "framer-motion";
import Logo from "./Logo";

const stats = [
  { value: "Contamos", label: "con Años de experiencia" },
  { value: "Nuestros", label: "Clientes quedan satisfechos" },
  { value: "Contamos", label: "con un Equipo Profesional" },
];

export const About = () => {
  return (
    <section
      id="nosotros"
      data-testid="about-section"
      className="relative bg-white py-16 md:py-32 overflow-hidden"
    >

      <div className="container-jr grid lg:grid-cols-2 gap-8 lg:gap-20 items-center">
        {/* Visual block */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.45, ease: "easeOut" }}
          className="relative"
        >
          {/* Technician photo card */}
          <div className="relative rounded-3xl overflow-hidden aspect-[4/5] shadow-jr-soft">
            {/* Reemplaza /about/gerente.jpg con la foto del gerente o equipo */}
            <img
              src="/about/gerente.jpg"
              alt="JR Aire Comfort - Sobre nosotros"
              className="w-full h-full object-cover"
              loading="lazy"
              decoding="async"
              width="600"
              height="750"
            />
            {/* Subtle overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-jr-oxford/40 via-transparent to-transparent" />
          </div>

          {/* Floating logo card */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3, duration: 0.6 }}
            className="absolute -bottom-6 -right-4 lg:-right-8 bg-white rounded-2xl shadow-jr-card px-6 py-5 flex items-center justify-center"
            data-testid="about-floating-card"
          >
            <Logo
              variant="isotipo"
              size={72}
              loading="lazy"
              dataTestId="about-floating-isotipo"
            />
          </motion.div>
        </motion.div>

        {/* Text block */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.45, ease: "easeOut" }}
        >
          <h2
            className="font-display font-semibold text-jr-oxford text-[28px] md:text-[40px] lg:text-[48px] leading-[1.1] tracking-[-0.02em]"
            data-testid="about-title"
          >
            Sobre Nosotros
          </h2>
          <div className="mt-4 h-[3px] w-[60px] bg-jr-cyan rounded-full" />

          <p
            className="mt-7 text-jr-gray-text text-[16px] md:text-[17px] leading-[1.75] font-light"
            data-testid="about-description"
          >
            <strong className="font-semibold text-jr-oxford">JR Aire Comfort</strong> es
            una empresa especializada en soluciones de climatización, ofreciendo
            instalación, mantenimiento y reparación de sistemas de aire acondicionado
            para hogares y negocios. Su enfoque se centra en brindar confort, eficiencia
            y tecnología a sus clientes, garantizando un servicio de alta calidad y
            personalizado. Con una identidad moderna y profesional, la marca representa
            frescura, confianza y compromiso con el bienestar ambiental y la innovación
            en climatización.
          </p>

          {/* Stats */}
          <div className="mt-10 grid grid-cols-3 gap-4 md:gap-6" data-testid="about-stats">
            {stats.map((s) => (
              <div
                key={s.label}
                className="border-l-2 border-jr-cyan pl-4 py-1"
              >
                <p className="font-display font-semibold text-jr-yale text-[15px] md:text-[15px] leading-none tracking-tight">
                  {s.value}
                </p>
                <p className="mt-2 text-jr-gray-text text-[11px] md:text-[12px] uppercase tracking-wider font-medium">
                  {s.label}
                </p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
